
























import { Component, Vue } from 'vue-property-decorator';
import Logo from '@/components/ui/Logo.vue';
import Navigation from './Navigation.vue';
import Languages from './Languages.vue';
import Hamburger from './Hamburger.vue';

@Component({
  components: {
    Logo,
    Navigation,
    Languages,
    Hamburger,
  },
})
export default class Header extends Vue {}
